<script lang="ts">
import { computed, defineComponent } from "vue";
import { getCurrentInstance } from "vue";

export default defineComponent({
  name: "Zelle",
  components: {},
  props: {
    breite: {
      type: Number,
      default: 6,
    },
    offset: Number,
    class: String,
    classOverride: {
      type: String,
      required: false,
    },
    dataCy: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const instance = getCurrentInstance();

    const allClasses = computed(() => {
      if (props.classOverride) {
        return props.classOverride;
      }

      return (
        "o-grid__cell o-grid__cell--12 o-grid__cell--" +
        props.breite +
        "-1024" +
        (props.offset ? " o-grid__cell--offset-" + props.offset + "-1024" : "") +
        (!instance?.parent?.props.spacingY ? " u-form-grid-nospace-y" : "") +
        (props.class ? " " + props.class : "")
      );
    });

    return {
      allClasses,
    };
  },
});
</script>

<template>
  <div :class="allClasses" :data-cy="dataCy">
    <slot></slot>
  </div>
</template>
